import { WarehouseDemandRequestStatus } from 'woofwoof-api';
import { WarehouseQueryKey, warehouseQueryKey } from './useWarehouseQuery';

/**
 * Review S3: the organization always follows the prefix, so two clinics
 * never share a cached entry and invalidation stays within one clinic.
 */
export const WAREHOUSE_DEMAND_QUERY_KEY = 'warehouse-demand';

/** The demand picker's part of a `warehouse-products` key, after the organization. */
export const DEMAND_PICKER_KEY_PART = 'demand-picker';

/** What `useWarehouseDemandRequests` puts after the organization. */
export function demandListParts(
  status: WarehouseDemandRequestStatus | undefined,
  page: number,
  limit: number,
): readonly unknown[] {
  return [status ?? 'ALL', page, limit];
}

/** Every Demand Request list of one organization: the invalidation prefix. */
export function demandScopeKey(
  organizationId: string | undefined,
): WarehouseQueryKey {
  return warehouseQueryKey(WAREHOUSE_DEMAND_QUERY_KEY, organizationId);
}

export function demandListKey(
  organizationId: string | undefined,
  status: WarehouseDemandRequestStatus | undefined,
  page: number,
  limit: number,
): WarehouseQueryKey {
  return warehouseQueryKey(
    WAREHOUSE_DEMAND_QUERY_KEY,
    organizationId,
    ...demandListParts(status, page, limit),
  );
}

export function demandProductPickerKey(
  organizationId: string | undefined,
  search: string,
): WarehouseQueryKey {
  return warehouseQueryKey(
    'warehouse-products',
    organizationId,
    DEMAND_PICKER_KEY_PART,
    search,
  );
}

/** The master's Product detail key, shared with Phase 1's `useWarehouseProduct`. */
export function demandProductLookupKey(
  organizationId: string | undefined,
  productId: string,
): WarehouseQueryKey {
  return warehouseQueryKey('warehouse-product', organizationId, productId);
}
